<template>
  <div class="home">
    <Navbar />
    <Homepage />
    <div class="page-slider">
      <Portfolio />
      <About />
      <Passions />
      <div class="go-to">
        <div class="count">
          <svg
            @click="goToPrev"
            class="arrow-prev"
            width="26"
            height="16"
            viewBox="0 0 26 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i)">
              <path
                d="M0.292893 7.29289C-0.0976314 7.68341 -0.0976315 8.31658 0.292892 8.7071L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6568L2.41421 7.99999L8.07107 2.34314C8.46159 1.95262 8.46159 1.31945 8.07107 0.928927C7.68055 0.538403 7.04738 0.538403 6.65686 0.928927L0.292893 7.29289ZM26 7L1 6.99999L1 8.99999L26 9L26 7Z"
                fill="#DDDDDD"
              />
            </g>
            <defs>
              <filter
                id="filter0_i"
                x="0"
                y="0.635986"
                width="26"
                height="18.7279"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow"
                />
              </filter>
            </defs>
          </svg>
          <div class="actual">
            2
          </div>
          <span>/</span>
          <div class="tot">
            3
          </div>
          <svg
            @click="goToNext"
            class="arrow-next"
            width="26"
            height="16"
            viewBox="0 0 26 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i)">
              <path
                d="M25.7071 8.70711C26.0976 8.31659 26.0976 7.68342 25.7071 7.2929L19.3431 0.928936C18.9526 0.538411 18.3195 0.538411 17.9289 0.928935C17.5384 1.31946 17.5384 1.95262 17.9289 2.34315L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.70711ZM-1.74846e-07 9L25 9L25 7L1.74846e-07 7L-1.74846e-07 9Z"
                fill="#DDDDDD"
              />
            </g>
            <defs>
              <filter
                id="filter0_i"
                x="0"
                y="0.635986"
                width="26"
                height="18.7279"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow"
                />
              </filter>
            </defs>
          </svg>
        </div>
      </div>
    </div>
    <Contacts />
    <div class="scroll-to" @click="scrollTo">
      <span class="arrow">
        <svg
          viewBox="0 0 223 411"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xml:space="preserve"
          xmlns:serif="http://www.serif.com/"
          style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-miterlimit:10;"
        >
          <path
            d="M73.778,231.261l37.5,56.25l37.5,-56.25"
            style="fill:none;stroke:#ddd;stroke-width:12.5px;"
          />
          <path
            d="M111.278,287.511l0,-176.233"
            style="fill:none;stroke:#ddd;stroke-width:12.5px;stroke-linejoin:round;stroke-miterlimit:1.5;"
          />
        </svg>
      </span>
      <span class="txt" id="scroll-goto">
        <small>Vai {{ scrollToText }}</small>
        <small class="scrollto-text">
          <span class="scrollto-text-span">{{ scrollToTextSpan }}</span>
        </small>
      </span>
    </div>
  </div>
</template>

<script>
import Homepage from "../components/Pages/Home/Homepage.vue";
import About from "../components/Pages/About/About.vue";
import Contacts from "../components/Pages/Contacts/Contacts.vue";
import Passions from "../components/Pages/About/Passions/Passions.vue";
import Portfolio from "../components/Pages/About/Portfolio/Portfolio.vue";
import Navbar from "../components/Header/Navbar.vue";
export default {
  name: "Home",
  components: {
    Homepage,
    About,
    Contacts,
    Portfolio,
    Passions,
    Navbar
  },
  data() {
    return {
      aboutActive: false,
      contactActive: false,
      scrollToText: "alla",
      scrollToTextSpan: "Presentazione",

      isVisible: false
    };
  },
  mounted() {
    let counter = document.querySelector(".actual");
    let passionsPage = document.getElementById("passions");
    let porfolioPage = document.getElementById("portfolio");
    let arrowPrev = document.querySelector(".arrow-prev");
    let arrowNext = document.querySelector(".arrow-next");
    let arrow = document.querySelector(".arrow");
    let who = document.querySelector(".who");
    addEventListener("scroll", () => {
      if (window.scrollY < window.innerHeight / 2) {
        this.scrollToText = "alla";
        this.scrollToTextSpan = "Presentazione";
        arrow.style.transform = "translateY(-2.5px)" + "rotate(0)";
      } else if (window.scrollY < window.innerHeight * 1.5) {
        this.scrollToText = "ai";
        this.scrollToTextSpan = "Contattti";
        arrow.style.transform = "translateY(-2.5px)" + "rotate(0)";
        if (porfolioPage.classList.contains("portfolioActive")) {
          counter.innerHTML = 1;
        }
      } else if (window.scrollY >= window.innerHeight * 1.5) {
        this.scrollToText = "alla";
        this.scrollToTextSpan = "Home";
        arrow.style.transform = "translateY(-2.5px)" + "rotate(180deg)";
      }
      if (
        (counter.innerHTML == 3 && window.scrollY < window.innerHeight / 2) ||
        (counter.innerHTML == 3 && window.scrollY > window.innerHeight * 1.2)
      ) {
        counter.innerHTML = 2;
        passionsPage.style.transform = "translateX(100%)";
        arrowNext.style.visibility = "visible";
      } else if (
        (counter.innerHTML == 1 && window.scrollY < window.innerHeight / 2) ||
        (counter.innerHTML == 1 && window.scrollY > window.innerHeight * 1.2)
      ) {
        // modify who logo (navbar)
        who.style.opacity = "1";
        who.style.transform = "translateX(0)";
        counter.innerHTML = 2;
        porfolioPage.style.transform = "translateX(-100%)";
        arrowPrev.style.visibility = "visible";
      }
    });
  },
  methods: {
    scrollTo() {
      if (window.scrollY < window.innerHeight / 2) {
        document.getElementById("about").scrollIntoView({ behavior: "smooth" });
      } else if (window.scrollY < window.innerHeight * 1.5) {
        document
          .getElementById("contacts")
          .scrollIntoView({ behavior: "smooth" });
      } else if (window.scrollY >= window.innerHeight * 1.5) {
        document.getElementById("home").scrollIntoView({ behavior: "smooth" });
      }
    },
    // Fake pages slider
    goToPrev() {
      // get cunter
      let counter = document.querySelector(".actual");
      // pages
      let porfolioPage = document.getElementById("portfolio");
      let aboutPage = document.getElementById("about");
      let passionsPage = document.getElementById("passions");

      // get who logo (navbar)
      let who = document.querySelector(".who");

      // scroll for better experience
      aboutPage.scrollIntoView({ behavior: "smooth" });

      // arrows
      let arrowPrev = document.querySelector(".arrow-prev");
      let arrowNext = document.querySelector(".arrow-next");
      if (counter.innerHTML == 2) {
        // modify who logo (navbar)
        who.style.opacity = "0";
        who.style.transform = "translateX(100px)";
        // show page
        porfolioPage.style.transform = "translateX(0)";
        // show page
        counter.innerHTML = 1;
        // change arrows
        arrowPrev.style.visibility = "hidden";
        arrowNext.style.visibility = "visible";
      } else if (counter.innerHTML == 3) {
        // hide page
        passionsPage.style.transform = "translateX(100%)";
        // change counter
        counter.innerHTML = 2;
        // change arrows
        arrowPrev.style.visibility = "visible";
        arrowNext.style.visibility = "visible";
      }
    },
    goToNext() {
      let counter = document.querySelector(".actual");
      // pages
      let porfolioPage = document.getElementById("portfolio");
      let aboutPage = document.getElementById("about");
      let passionsPage = document.getElementById("passions");

      // get who logo (navbar)
      let who = document.querySelector(".who");

      // scroll for better experience
      aboutPage.scrollIntoView({ behavior: "smooth" });

      // arrows
      let arrowPrev = document.querySelector(".arrow-prev");
      let arrowNext = document.querySelector(".arrow-next");

      if (counter.innerHTML == 2) {
        // show page
        passionsPage.style.transform = "translateX(0)";
        // show page
        counter.innerHTML = 3;
        // change arrows
        arrowNext.style.visibility = "hidden";
        arrowPrev.style.visibility = "visible";
      } else if (counter.innerHTML == 1) {
        // modify who logo (navbar)
        who.style.opacity = "1";
        who.style.transform = "translateX(0)";
        // hide page
        porfolioPage.style.transform = "translateX(-100%)";
        // change counter
        counter.innerHTML = 2;
        // change arrows
        arrowPrev.style.visibility = "visible";
        arrowNext.style.visibility = "visible";
      }
    }
  },
  destroy() {
    window.removeEventListener("scroll");
  }
};
</script>

<style lang="scss">
.home {
  width: 100%;
  .page-slider {
    position: relative;
    display: flex;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    #portfolio,
    #about,
    #passions {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 3;
      transition: transform 800ms cubic-bezier(0.64, -0.39, 0.39, 1.46);
    }
    #portfolio {
      transform: translateX(-100%);
    }
    #about {
      z-index: 1;
    }
    #passions {
      transform: translateX(100%);
    }
  }
}
</style>
